<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M12 4V15M12 15L8 11M12 15L16 11"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path d="M5 19H19" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
</svg>
